import { xhr } from '@/api/config/Repository'
import ReportsDetailsRepository from '../ReportsDetailsRepository'
import ReportsRequestDTO from '../dto/ReportsRequestDTO'

export default class ReportsDetailsRepositoryImpl implements ReportsDetailsRepository {
  async getReportsDetails (request: ReportsRequestDTO): Promise<any> {
    const endpoint = '/md/export-Report'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<ReportsRequestDTO, any>(endpoint, request, { headers })
    return {
      data: response.data,
      status: response.status
    }
  }
}
